import React from "react";
import { Card, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Fade, Slide } from "react-awesome-reveal";

const CategoryCard = ({ background, img, title, id }) => {
  const navigate = useNavigate();

  return (
    <div className="noon-category-card" onClick={() => navigate(`/category/subcategory/${id}`)}>
      <Fade>
        <div className="noon-category-img-box">
          <img
            src={img}
            loading="lazy"
            alt={title}
            className="noon-category-img"
          />
        </div>
        <div className="noon-category-text">{title}</div>
      </Fade>
    </div>
  );
};

export default CategoryCard;
